module.exports = __webpack_public_path__ + "static/open-sans-v27-latin-regular-d65113b6da7ba4bd0a59dbda5a7e24d4.woff2";